<template>
    <div class="footer">
        <v-row>
            <v-col md="8" sm="8" lg="8" cols="12" style="background: #022c46;">
                <v-row>
                    <v-col md="4" sm="4" lg="4" cols="12" align="center">
                        <h4 class="footer__text">{{$t('courses')}}</h4>
                        <div class="footer-widget__link-wrap">
                            <ul class="list-unstyled footer-widget__link-list" style="text-align: left;">
                                <li><a href="/student/courses/beginner">{{$t('beginner')}}</a></li>
                                <li><a href="/student/courses/elementary">{{$t('elementary')}}</a></li>
                                <li><a href="/student/courses/pre-intermediate">{{$t('preinter')}}</a></li>
                            </ul><!-- /.footer-widget__link-list -->
                            <ul class="list-unstyled footer-widget__link-list" style="text-align: left;">
                                <li><a href="#">{{$t('ort')}}</a></li>
                                <li><a href="#">{{$t('ort2')}}</a></li>
                            </ul><!-- /.footer-widget__link-list -->
                        </div>
                    </v-col>
                    <v-col md="4" sm="4" lg="4" cols="12" align="center">
                        <h4 class="footer__text">{{$t('exploref')}}</h4>
                        <div class="footer-widget__link-wrap">
                            <ul class="list-unstyled footer-widget__link-list" style="text-align: left;">
                                <li><a href="/about">{{$t('about')}}</a></li>
                                <li><a href="/teachers">{{$t('teachers')}}</a></li>
                                <li><a href="#">{{$t('join')}}</a></li>
                            </ul><!-- /.footer-widget__link-list -->
                            <ul class="list-unstyled footer-widget__link-list" style="text-align: left;">
                                <li><a href="/news">{{$t('news')}}</a></li>
                                <li><a href="#">{{$t('help')}}</a></li>
                                <li><a href="#">{{$t('contact')}}</a></li>
                            </ul><!-- /.footer-widget__link-list -->
                        </div>
                    </v-col>
                    <v-col md="4" sm="4" lg="4" cols="12" align="center">
                        <h4 class="footer__text">{{$t('gallery')}}</h4>
                        <ul class="list-unstyled footer-widget__gallery-list" style="margin-top: 10px; padding: 0px 50px;">
                            <li><a href="#"><img :src="require('../../assets/images/footer-1-1.png')" alt=""></a></li>
                            <li><a href="#"><img :src="require('../../assets/images/footer-1-2.png')" alt=""></a></li>
                            <li><a href="#"><img :src="require('../../assets/images/footer-1-3.png')" alt=""></a></li>
                            <li><a href="#"><img :src="require('../../assets/images/footer-1-4.png')" alt=""></a></li>
                            <li><a href="#"><img :src="require('../../assets/images/footer-1-5.png')" alt=""></a></li>
                            <li><a href="#"><img :src="require('../../assets/images/footer-1-6.png')" alt=""></a></li>
                        </ul>
                    </v-col>
                </v-row>
            </v-col>
            <v-col md="4" sm="4" lg="4" cols="12" align="center" style="background:#012237">
                <h4 class="footer__text">{{$t('about')}}</h4>
                <p class="footer__about__p">{{$t('besttext')}}</p>
                <v-btn color="#f16101" class="footer__about__btns mr-2 ml-2">{{$t('contact')}}</v-btn>
                <!--<v-btn color="#2da397" class="footer__about__btns mr-2 ml-2">{{$t('courses')}}Purchase</v-btn>-->
            </v-col>
            <v-col md="12" sm="12" lg="12" cols="12">
                <v-row>
                    <v-col md="8" sm="8" lg="8" cols="12" style="padding-top: 0px; padding-right: 0px;background:#012237" align="center">
                        <p class="footer__copyright__text" style="margin: 0 auto; padding-top: 40px;">&copy; Copyright 2020 by <a href="#" class="footer__copyright__text__a ml-1"> zhyldyzacademy.kg</a></p>
                    
                    </v-col>
                    <v-col md="4" sm="4" lg="4" cols="12" style="padding-top: 0px; padding-left: 0px;">
                        <div class="site-footer__social">
                            <a href="#" data-target="html" class="scroll-to-target site-footer__scroll-top"><i class="kipso-icon-top-arrow"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-twitter fa-lg"></i></a>
                            <a href="https://www.facebook.com/zhyldyz.academy" target="_blank"><i class="fab fa-facebook-square fa-lg"></i></a>
                            <a href="https://api.whatsapp.com/send/?phone=%2B996704949501&text&app_absent=0" target="_blank"><i class="fab fa-whatsapp fa-lg"></i></a>
                            <a href="https://www.instagram.com/zhyldyz_academy/" target="_blank"><i class="fab fa-instagram fa-lg"></i></a>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    name: "Footer",
    methods: {
        goTo(url) {
          if(url === 'hello') {
              console.log('clicked')
                //this.$router.push({name: 'courseBeginner'});
            }
            else if (url === 'elementary')
            {
                this.$router.push({name: 'courseElementary'});
            }
            else if (url === 'pre-intermediate')
            {
                this.$router.push({name: 'coursePreIntermediate'});
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.footer {
    font-family: "Poppins";
    &__text {
        color: #fff;
        padding-top: 20px;
    }
    &__about {
        &__p {
            font-size: 15px;
            line-height: 30px;
            color: #94a3ac;
            margin: 20px 10px;
            font-family: "Poppins";
            text-align: left;
        }
        &__btns {
            color: #fff !important;
            margin-top: 20px;
        }
    }
    &__copyright {
        &__text{
            font-family: "Poppins";
            font-weight: 700;
            color:#94a3ac;
            &__a {
                color: #f16101;
                &:hover {
                    color:#fff;
                }
            }
        }
    }
}
.footer-widget__link-wrap {
    padding-top: 20px;
}
@media screen and (min-width: 300px) and (max-width: 500px) {
    .footer {
        font-family: "Poppins";
        background: #012237;
        &__text {
            color: #fff;
            padding-top: 20px;
        }
        &__about {
            &__p {
                font-size: 15px;
                line-height: 30px;
                color: #94a3ac;
                margin: 20px 10px;
                font-family: "Poppins";
                text-align: left;
            }
            &__btns {
                color: #fff !important;
                margin-top: 20px;
            }
        }
        &__copyright {
            &__text{
                font-family: "Poppins";
                font-weight: 700;
                color:#94a3ac;
                &__a {
                    color: #f16101;
                    &:hover {
                        color:#fff;
                    }
                }
            }
        }
    }
    .site-footer__scroll-top {
       display: none;
    }
    .site-footer__social a  {
        padding-left: 10px;
    }
    .list-unstyled {
        padding: 25px;
        margin-top: 20px;
    }
    .footer-widget__link-wrap {
        padding-top: 0px;
    }
}
</style>